import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type {
	CreateStaffingData,
	Staffing,
	StaffingIsEditable,
	StaffingWithRelations,
	UpdateStaffingData,
	UsersActiveStaffingsResponse,
} from "~/modules/project/api/staffing/staffingTypes.ts";

interface CreateStaffingParamsType {
	projectId: string;
	staffingData: CreateStaffingData;
}

interface UpdateStaffingParamsType {
	projectId: string;
	staffingId: string;
	staffingData: UpdateStaffingData;
}

export function indexStaffingByProjectId({
	projectId,
}: {
	projectId: string;
}): AxiosApiResponsePromise<Staffing[]> {
	return axiosApi.get(`projects/${projectId}/staffings`);
}

export function createStaffing({
	projectId,
	staffingData,
}: CreateStaffingParamsType): AxiosApiResponsePromise<Staffing> {
	return axiosApi.post(`projects/${projectId}/staffings`, { ...staffingData });
}

export function createAdditionalStaffingForUser({
	projectId,
	userId,
	staffingData,
}: { projectId: string; userId: string, staffingData: CreateStaffingData }): AxiosApiResponsePromise<Staffing> {
	return axiosApi.post(`projects/${projectId}/staffings/${userId}`, { ...staffingData });
}

export function checkIfStaffingIsEditable({
	projectId,
	staffingId,
}: {
	projectId: string;
	staffingId: string;
}): AxiosApiResponsePromise<StaffingIsEditable> {
	return axiosApi.get(`projects/${projectId}/staffings/${staffingId}/editable-check`);
}

export function showStaffing({
	projectId,
	staffingId,
}: {
	projectId: string;
	staffingId: string;
}): AxiosApiResponsePromise<StaffingWithRelations> {
	return axiosApi.get(`projects/${projectId}/staffings/${staffingId}`);
}

/** `month` is `YYYY-MM`. Without it the backend offers the staffings of the current month. */
export async function indexUsersActiveStaffings({
	userId,
	month,
}: {
	userId: string;
	month?: string;
}): AxiosApiResponsePromise<UsersActiveStaffingsResponse> {
	return axiosApi.get(`users/${userId}/staffings/active`, { params: { month } });
}

export function updateStaffing({
	projectId,
	staffingId,
	staffingData,
}: UpdateStaffingParamsType): AxiosApiResponsePromise<Staffing> {
	return axiosApi.put(`/projects/${projectId}/staffings/${staffingId}`, staffingData);
}

export function updateStaffingActivity({
	projectId,
	staffingId,
	isActive,
}: { projectId: string, staffingId: string, isActive: boolean }): AxiosApiResponsePromise<Staffing> {
	return axiosApi.patch(`/projects/${projectId}/staffings/${staffingId}/activity`, { isActive });
}


export function deleteStaffing({
	projectId,
	staffingId,
}: {
	projectId: string;
	staffingId: string;
}): AxiosApiResponsePromise<void> {
	return axiosApi.delete(`/projects/${projectId}/staffings/${staffingId}`);
}
